import React, { useState, useEffect } from 'react'

const API_URL = 'https://api.tutormatchae.com/tutor-match-ae/v1/webhook/get-cms-details';

const AboutUs = () => {
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchAboutData = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await fetch(API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ tag_name: 'about_us' }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const result = await response.json();
            if (result) {
                setPageData(result);
            } else {
                throw new Error(result.message || 'Failed to fetch data');
            }
        } catch (err) {
            console.error('Error fetching about us data:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAboutData();
    }, []);

    return (
        <>
            <main className="flex-1">
                {/* Hero Section */}
                <section className="px-4 sm:px-6 lg:px-8 xl:px-40 flex justify-center py-8 sm:py-12 md:py-20">
                    <div className="layout-content-container flex flex-col max-w-[960px] flex-1">
                        <div className="@container">
                            <div className="@[480px]:p-0">
                                <div
                                    className="flex min-h-[300px] sm:min-h-[420px] flex-col gap-4 sm:gap-6 bg-cover bg-center bg-no-repeat @[480px]:gap-8 rounded-xl items-center justify-center p-6 sm:p-8 shadow-xl"
                                    data-alt="People studying together in a brightly lit modern library environment"
                                    style={{
                                        backgroundImage:
                                            'linear-gradient(rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.6) 100%), url("/assets/about.png")'
                                    }}
                                >
                                    <div className="flex flex-col gap-4 text-center max-w-[700px]">
                                        <h1 className="text-white text-2xl sm:text-3xl lg:text-4xl xl:text-6xl font-black leading-tight tracking-[-0.033em]">
                                            Empowering every learner through personalised tutoring
                                        </h1>
                                        <h2 className="text-white/90 text-sm sm:text-base lg:text-xl font-normal leading-relaxed">
                                            Our mission is to make high-quality tutoring accessible, transparent and trustworthy. Giving families the confidence to choose what’s right for them.
                                        </h2>
                                    </div>
                                    {/* <button className="flex min-w-[160px] cursor-pointer items-center justify-center rounded-lg h-12 px-6 bg-primary text-white text-base font-bold shadow-lg hover:bg-opacity-90 transition-all">
                                        Join Our Community
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Mission/Story Section */}
                <section className="bg-white dark:bg-white/5 py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 xl:px-40">
                    <div className="max-w-[960px] mx-auto">
                        <div className="prose prose-slate max-w-none overflow-hidden break-words" style={{ overflowWrap: 'break-word', wordBreak: 'break-word' }}>
                            {loading ? (
                                <div className="flex justify-center items-center py-12">
                                    <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-primary"></div>
                                </div>
                            ) : error ? (
                                <div className="text-center py-8">
                                    <p className="text-red-500 mb-4">Failed to load content.</p>
                                    <button
                                        onClick={fetchAboutData}
                                        className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-opacity-90 transition-all"
                                    >
                                        Retry
                                    </button>
                                </div>
                            ) : pageData?.content ? (
                                <div dangerouslySetInnerHTML={{ __html: pageData.content }} />
                            ) : (
                                <p className="text-slate-600">No content available.</p>
                            )}
                        </div>
                    </div>
                </section>
                {/* Human Centric / Team Section */}

                {/* Values Section */}
                <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 xl:px-40 bg-white dark:bg-white/5">
                    <div className="max-w-[960px] mx-auto">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12">
                            <div className="p-6 rounded-xl border border-[#e7f3ee] dark:border-white/10 bg-background-light/50 dark:bg-background-dark/50">
                                <div className="text-primary mb-4">
                                    <span className="material-symbols-outlined text-4xl">
                                        diversity_3
                                    </span>
                                </div>
                                <h4 className="text-lg font-bold mb-2 dark:text-white">
                                    Accessibility
                                </h4>
                                <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                                    High-quality tutoring should be easy to access, clear to navigate, and designed around real family needs.
                                </p>
                            </div>
                            <div className="p-6 rounded-xl border border-[#e7f3ee] dark:border-white/10 bg-background-light/50 dark:bg-background-dark/50">
                                <div className="text-primary mb-4">
                                    <span className="material-symbols-outlined text-4xl">security</span>
                                </div>
                                <h4 className="text-lg font-bold mb-2 dark:text-white">
                                    Unwavering Trust
                                </h4>
                                <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                                    Trust sits at the heart of the platform, with identity and permit checks in place to support safe, transparent tutoring.
                                </p>
                            </div>
                            <div className="p-6 rounded-xl border border-[#e7f3ee] dark:border-white/10 bg-background-light/50 dark:bg-background-dark/50">
                                <div className="text-primary mb-4">
                                    <span className="material-symbols-outlined text-4xl">
                                        auto_awesome
                                    </span>
                                </div>
                                <h4 className="text-lg font-bold mb-2 dark:text-white">
                                    Human Connection
                                </h4>
                                <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                                    Meaningful learning is built through strong human connection, understanding, and supportive relationships.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Final CTA */}
                <section className="py-12 sm:py-16 lg:py-24 px-4 sm:px-6 lg:px-8 xl:px-40">
                    <div className="max-w-[960px] mx-auto text-center rounded-2xl bg-primary p-8 sm:p-12 shadow-2xl overflow-hidden relative">
                        {/* Subtle pattern background */}
                        <div
                            className="absolute inset-0 opacity-10"
                            style={{
                                backgroundImage: "radial-gradient(#fff 2px, transparent 2px)",
                                backgroundSize: "30px 30px"
                            }}
                        ></div>
                        <div className="relative z-10">
                            <h2 className="text-white text-2xl sm:text-3xl lg:text-4xl font-black mb-4 sm:mb-6">
                                Ready to start your journey?
                            </h2>
                            <p className="text-white/80 text-base sm:text-lg mb-8 sm:mb-10 max-w-[600px] mx-auto">
                                Download the app and join Tutor Match AE today.
                            </p>
                            <div className="flex flex-col sm:flex-row justify-center gap-4 mt-6">
                                {/* Google Play */}
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.tutormatchae.app"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-block"
                                >
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/Google_Play_Store_badge_EN.svg"}
                                        alt="Get it on Google Play"
                                        className="h-12 sm:h-14"
                                    />
                                </a>
                                {/* App Store */}
                                <a
                                    href="https://apps.apple.com/us/app/tutor-match-ae/id6760763052"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/download-on-the-app-store.svg"}
                                        alt="Download on the App Store"
                                        className="h-12 sm:h-14"
                                    />
                                </a>
                            </div>
                            {/* Instagram */}
                            <div className="pt-6 mt-4 border-t border-white/15">
                                <a
                                    href="https://www.instagram.com/tutormatch_ae?igsh=MXM4bm5sYmE1ODBrbw%3D%3D&utm_source=qr"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-4 px-6 py-3 rounded-2xl bg-white/10 hover:bg-white/[0.18] backdrop-blur-sm border border-white/10 hover:border-white/25 transition-all duration-300 group"
                                >
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/instagram.svg"}
                                        alt="Instagram"
                                        className="size-10 rounded-xl group-hover:scale-105 transition-transform duration-300"
                                    />
                                    <div className="flex flex-col items-start text-left">
                                        <span className="text-xs text-white/50 uppercase tracking-wider font-medium leading-none mb-1">Follow us on Instagram</span>
                                        <span className="text-base font-bold text-white leading-tight">@tutormatch_ae</span>
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-5 text-white/40 group-hover:text-white/70 group-hover:translate-x-0.5 transition-all duration-300 ml-2">
                                        <path fillRule="evenodd" d="M3 10a.75.75 0 0 1 .75-.75h10.638L10.23 5.29a.75.75 0 1 1 1.04-1.08l5.5 5.25a.75.75 0 0 1 0 1.08l-5.5 5.25a.75.75 0 1 1-1.04-1.08l4.158-3.96H3.75A.75.75 0 0 1 3 10Z" clipRule="evenodd" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
}

export default AboutUs